import { Checkbox, Text } from "@mantine/core";

type TemplateCheckboxProps = {
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled: boolean;
};

export function TemplateCheckbox({
	checked,
	onChange,
	disabled,
}: TemplateCheckboxProps) {
	return (
		<Checkbox.Card
			checked={checked}
			onChange={onChange}
			disabled={disabled}
			className="border-0 pt-2"
		>
			<div className="flex w-full items-start justify-between gap-3">
				<div className="flex-1 space-y-1 text-left">
					<Text size="sm" fw={600}>
						Publish as template
					</Text>
					<Text size="xs" c="dimmed">
						Let others duplicate this board from the public link.
					</Text>
				</div>
				<Checkbox.Indicator
					checked={checked}
					disabled={disabled}
					color="var(--ui-color-brand-primary)"
					className={disabled ? "cursor-not-allowed" : "cursor-pointer"}
				/>
			</div>
		</Checkbox.Card>
	);
}
